import enUS from "./en-US.json"
import svSE from "./sv-SE.json"

export const resources = {
  "en-US": { translation: enUS },
  "sv-SE": { translation: svSE },
}
